/* === BEGIN imported: modalPages/overSizeLuggage.jsx (verbatim from plugin, with phase-1 routing deviation) === */
import React, {useState} from "react";
import NumberCounter from "@/customComponents/uiComponents/global/NumberCounter.jsx";
import {tripService} from "@/services/tripService";
import {Loader} from "@/customComponents/uiComponents/Loader.jsx";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {useLuggageTypes} from "@/hooks/useSelectables";
import {arrowRightWhite} from "@img/index.js";
import {ModalFooter} from "../Components/BookingModalShell.jsx";

export function OverSizeLuggage({setStep, closeModal}) {
    const [recalculateError, setRecalculateError] = useState(false);
    const [recalculate, setRecalculate] = useState(false);
    const {data: passengerOversizeLuggageDb = []} = useLuggageTypes();

    return (
        <>
            <ModalHeader
                title="Add Oversized"
                extraClasses=""
                totalSteps={2}
                cancelButton={false}
                cancelButtonType="text"
                backStep="passengerLuggage"
                showBackButton={true}
                enableEditModeOnBackButton={false}
                setStep={setStep}
                closeModal={closeModal}
            />

            <div className="modalPages-spacing">
                <div className="little-title">
                    <h2>Add Oversized</h2>
                </div>
                <div className="hopn-oversized-selector">
                    {
                        passengerOversizeLuggageDb.length === 0
                            ? <Loader/>
                            :
                            passengerOversizeLuggageDb
                                .filter(option => option.category === 'Oversized')
                                .reverse()
                                .map((option, index) => (
                                    <div className="hopn-item-box" key={option.id ?? index}>
                                        <div className="hopn-item-header">
                                            <span className="hopn-item-label">{option.label}</span>
                                            <span className="hopn-item-icon"><img
                                                src={option.image_url}
                                                alt="Bicycle"/></span>
                                        </div>
                                        <div className="hopn-quantity-control">
                                            <NumberCounter id={`oversizedLuggage-${option.id}`} variant="booking"/>
                                        </div>
                                    </div>
                                ))
                    }
                </div>
            </div>
            <ModalFooter>
                {
                    storage.get(STORAGE_KEYS.EDIT_STEP) === true
                        ? (
                            <>
                                {recalculateError !== false && (<div className="error-message">{recalculateError}</div>)}
                                <button
                                    className="hopn-add-passenger-button no-icon"
                                    disabled={recalculate}
                                    onClick={async () => {
                                        setRecalculate(true)
                                        const res = await tripService.recalculateCost();
                                        setRecalculate(false)
                                        storage.set(STORAGE_KEYS.SUMMARY_MESSAGE, true);
                                        if (res.success) {
                                            storage.set(STORAGE_KEYS.SUMMARY_MESSAGE, true);
                                            setStep('orderDetails');
                                        } else {
                                            console.error(res);
                                            setRecalculateError(res.error)
                                        }
                                    }}
                                >
                                    {recalculate ? <Loader color="#fff"/> : "Done"}
                                </button>
                            </>
                        )
                        : (
                            <button
                                className="hopn-add-passenger-button calendar"
                                disabled={!(passengerOversizeLuggageDb.length)}
                                onClick={() => setStep('travelingDateTime')}
                            >
                                {passengerOversizeLuggageDb.length === 0 ? <Loader/> : "+Date & Time"}
                                <img src={arrowRightWhite} alt="Arrow right"/>
                            </button>
                        )
                }
            </ModalFooter>
        </>
    )
}

export default OverSizeLuggage;
/* === END imported: modalPages/overSizeLuggage.jsx === */
